export default {
      id: "ic_copy_new-usage",
      viewBox: "0 0 12 12",
      url: "/" + "images/icons.3.109.2.svg#ic_copy_new-usage",
      toString: function () {
        return this.url;
      }
    }